import { gql } from '@apollo/client';

export interface GetClassesResponse {
    classes: {
        id: string;
        name: string;
        className: string;
        studentsCount: number;
        schoolYear: string;
    }[];
    classesCount: number;
}

export const GET_CLASSES = gql`
    query GetClasses($skip: Int, $take: Int, $orderBy: [ClassOrderByInput!], $where: ClassWhereInput) {
        classes(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
            id
            name
            className
            studentsCount(where: { NOT: [{ user: null }] })
            schoolYear
        }
        classesCount(where: $where)
    }
`;
